import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "20",
            height: "16",
            x: "2",
            y: "4",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M6 8h.001", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 8h.001", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 8h.001", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 8h.001", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 12h.001", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12h.001", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 12h.001", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 16h10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Keyboard";
const Keyboard = memo(themed(Icon));
export {
  Keyboard
};
//# sourceMappingURL=keyboard.js.map
